import ResponsiveTwoColumnLayout from '@/components/ui/ResponsiveTwoColumnLayout';
import useTheme from '@/theme/useTheme';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';

import LocalizedLink from '@/components/ui/LocalizedLink';
import Image, { StaticImageData } from 'next/image';
import moonRush from './assets/rush.png';
import moonCrash from './assets/crash.jpg';
import casinoImg from './assets/casino.png';
import sportImg from './assets/sports.png';

import { useAtomValue } from 'jotai';
import { isLoggedIn } from '@/state/userInfo';
import { globalModals } from '@/state/globalSettings';
import { useSetAtom } from 'jotai/index';
import Link from 'next/link';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CasinoAndSportBoxProps {}

const GameBox = (props: {
  title: string;
  imgSrc: StaticImageData;
  des: string;
  link: string;
}) => {
  const { title, imgSrc, des, link } = props;
  const { theme } = useTheme();

  const isLogin = useAtomValue(isLoggedIn);

  const setModals = useSetAtom(globalModals);

  return (
    <Link
      href={link}
      onClick={(e) => {
        // The Game can be accessed directly without logging in
      }}
      shallow
    >
      {/* <Typography sx={{ mb: '10px' }} variant={'h4'}>
          {title}
        </Typography> */}
      <Box
        sx={{
          padding: theme.spacing(1, 1),
          background: theme.palette.grey['800'],
          borderRadius: '24px',
        }}
      >
        <Box
          sx={{
            aspectRatio: '2',
            position: 'relative',
          }}
        >
          <Image
            src={imgSrc}
            alt={title}
            placeholder="blur"
            priority
            fill
            style={{
              borderRadius: 24,
            }}
          />
        </Box>
        <Typography
          sx={{
            mt: theme.spacing(1),
            md: theme.spacing(1),
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            textTransform: 'uppercase',
          }}
          variant={'subtitle2'}
          textAlign={'center'}
          lineHeight={'20px'}
          fontWeight={'500'}
        >
          {des}
        </Typography>
      </Box>
    </Link>
  );
};

export const CasinoAndSportBox: React.FC<CasinoAndSportBoxProps> = (props) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const leftConfig = {
    title: t('Casino'),
    imgSrc: casinoImg,
    des: t('Go to Casino'),
    link: '/casino',
  };

  const rightConfig = {
    title: t('Sports'),
    imgSrc: sportImg,
    des: t('Go to Sports'),
    link: '/sports',
  };
  return (
    <ResponsiveTwoColumnLayout
      leftComponent={<GameBox {...leftConfig}></GameBox>}
      rightComponent={<GameBox {...rightConfig}></GameBox>}
    />
  );
};

export default CasinoAndSportBox;
